import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import Header from './Components/Header';
import Hero from './Components/Hero';
import Books from './Components/Books';
import About from './Components/About';
import BookDetails from './Components/BookDetails';
import Menu from './Components/Menu';
import Contact from './Components/Contact';
import ExternalRedirect from './ExternalRedirect';
import Footer from './Components/Footer';
import PrivacyPolicy from './Components/PrivacyPolicy';
import SouthPlainfieldHerald from './Components/SouthPlainfieldHerald';
import RiverCityRegister from './Components/RiverCityRegister';
import Downloads from './Components/Downloads';
import NextBook from './Components/NextBook';
import LandingPage from './Components/LandingPage';
import AISearch from './Components/AISearch';
import ManufacturingMurder from './Components/ManufacturingMurder';
import InheritingMurder from './Components/InheritingMurder.js';
import NetworkingMurder from './Components/NetworkingMurder';
import CaseFile from './Components/CaseFile';
import CaseAnswer from './Components/CaseAnswer';
import ThankYou from './Components/ThankYou';
import Standings from './Components/Standings';
import MyRecord from './Components/MyRecord';

function RemoveTrailingSlash() {
  const location = useLocation();
  const { pathname, search, hash } = location;

  if (pathname.length > 1 && pathname.endsWith('/')) {
    const cleanPathname = pathname.replace(/\/+$/, '');

    return (
      <Navigate
        to={`${cleanPathname}${search}${hash}`}
        replace
      />
    );
  }

  return null;
}

function App() {
  return (
    <Router>
      <RemoveTrailingSlash />

      <div className="App full-bleed">
        <Header />
        <Menu />

        <Routes>
          <Route path="/" element={<Hero />} />

          <Route path="/books/manufacturing-murder" element={<ManufacturingMurder />} />
          <Route path="/books/inheriting-murder" element={<InheritingMurder />} />
          <Route path="/books/networking-murder" element={<NetworkingMurder />} />
          <Route path="/books/*" element={<Books category="All Books" />} />

          <Route path="/about" element={<About />} />
          <Route path="/podcast" element={<ExternalRedirect url="https://podcasters.spotify.com/pod/show/jerry-evanoff2" />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/murder-mystery" element={<Books category="murderMystery" />} />
          <Route path="/time-travel" element={<Books category="timeTravel" />} />
          <Route path="/case-file" element={<CaseFile />} />
          <Route path="/puzzle" element={<CaseFile />} />
          <Route path="/answer" element={<CaseAnswer />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/standings" element={<Standings />} />
          <Route path="/my-record" element={<MyRecord />} />

          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/bookdetails/:bookIndex" element={<BookDetails />} />

          <Route path="/southplainfieldherald" element={<SouthPlainfieldHerald />} />
          <Route path="/rivercityregister" element={<RiverCityRegister />} />

          <Route path="/downloads" element={<Downloads />} />
          <Route path="/next" element={<NextBook />} />
          <Route path="/landingpage" element={<LandingPage />} />
          <Route path="/aisearch" element={<AISearch />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;